const useGetCurrentsTools = () => {

  const getCurrentsTools = (containers, currentsTools, currentToolIds, option = {event:"onLoad", type:"byId"}) => {
    
    if (!containers.metaData) return;
    if (containers.metaData.map(item => {
      
      if ( (option.type == "byId" && currentToolIds.includes(item.id)) || (option.type == "byGlobalId" && currentToolIds.includes(item.globalId))  ) {
        
        currentsTools.push(getComponentbyEvent(item, option.event));
      }
      getCurrentsTools(item, currentsTools, currentToolIds, option);
    }));
  };

  const getComponentbyEvent = (component, event) => {
    var copyComponent = {...component}
    if (event != "onLoad") {
      copyComponent["conditions"] = undefined
      copyComponent["api"] = undefined
    }
    
    if (copyComponent.events ) {
      let eventValue = copyComponent.events[event]
      
      if (eventValue) {
        
        if (eventValue.styles) copyComponent.styles = {...copyComponent.styles, ...eventValue.styles}
        if (eventValue.conditions) copyComponent["conditions"] = eventValue.conditions
        if (eventValue.api) copyComponent["api"] = eventValue.api
      }
    } 
    
    
    return copyComponent
    

  };

  return getCurrentsTools;
};

export default useGetCurrentsTools;
